import {spawn, Thread} from "threads";

export const shapeFileParser = async (file: any) => {
	const workers = await spawn(new Worker(new URL('../workers/readShapefilesFromZip', import.meta.url), {type: 'module'}));
	const data = await workers(file);
	await Thread.terminate(workers);
	return data;
}
